import { useState, useEffect } from "react";
import { Grid, Typography, TextField, Paper } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { saveValue, userSelector } from "../store/slices/userSlice";

import regex from "../utils/regex";
import { validationMessages } from "src/constants";

import GoogleAddressSearch from "./GoogleAddressSearch";
import {
  updateAddress,
  updateEmail,
  updatePhoneNumber,
} from "src/store/slices/organisationSlice";

export default function OrganisationProfile() {
  const dispatch = useDispatch();
  const { organisation } = useSelector(userSelector);

  const savedEmail = organisation?.email?.address || "";
  const savedPhoneNumber = organisation?.phoneNumber?.number || "";

  const [email, setEmail] = useState(savedEmail);
  const [phoneNumber, setPhoneNumber] = useState(savedPhoneNumber);

  const emailError = email !== savedEmail && !regex.email.test(email);

  // On a page refresh the organisation only arrives once user/validate returns, after the first render
  useEffect(() => setEmail(savedEmail), [savedEmail]);
  useEffect(() => setPhoneNumber(savedPhoneNumber), [savedPhoneNumber]);

  // The update thunks only write to the organisation slice, so each save is mirrored into the user slice these fields read from
  async function handleUpdateEmail() {
    if (email === savedEmail || emailError) return;

    await dispatch(
      updateEmail({ email, organisationId: organisation._id })
    ).unwrap();
    dispatch(saveValue({ organisation: { email: { address: email } } }));
  }

  async function handleUpdatePhoneNumber() {
    if (phoneNumber === savedPhoneNumber) return;

    await dispatch(
      updatePhoneNumber({ phoneNumber, organisationId: organisation._id })
    ).unwrap();
    dispatch(
      saveValue({ organisation: { phoneNumber: { number: phoneNumber } } })
    );
  }

  async function handleUpdateAddress(newAddress) {
    if (!newAddress) return;

    await dispatch(
      updateAddress({ address: newAddress, organisationId: organisation._id })
    ).unwrap();
    dispatch(
      saveValue({
        organisation: { address: { fullAddress: newAddress.description } },
      })
    );
  }

  return (
    <Grid
      container
      item
      height="100%"
      width="100%"
      justifyContent="center"
      alignItems="center"
      style={{ marginTop: "64px" }}
    >
      <Grid
        container
        item
        xs={12}
        sm={10}
        md={10}
        xl={8}
        height="100vh"
        alignItems="center"
        direction="column"
        style={{ padding: "0 100px", marginTop: "64px" }}
      >
        <Paper style={{ padding: "40px" }}>
          <Typography
            variant="h5"
            fontWeight="800"
            style={{ letterSpacing: "-1.2px" }}
          >
            Organisation profile
          </Typography>
          <br />
          <br />

          <Typography variant="body2" style={{ textAlign: "left" }}>
            Name
          </Typography>
          <Typography
            variant="body2"
            style={{ textAlign: "left", margin: "0 0 20px" }}
          >
            {organisation?.name}
          </Typography>
          <Typography variant="body2" style={{ textAlign: "left" }}>
            ABN
          </Typography>
          <Typography
            variant="body2"
            style={{ textAlign: "left", margin: "0 0 20px" }}
          >
            {organisation?.abn}
          </Typography>

          <TextField
            fullWidth
            type="email"
            name="email"
            label="Email"
            autoComplete="email"
            size="small"
            value={email}
            onChange={(event) => setEmail(event.target.value.trim())}
            onBlur={handleUpdateEmail}
            margin="dense"
            error={emailError}
            helperText={emailError ? validationMessages.INVALID_EMAIL : " "}
            inputProps={{ maxLength: 50 }}
          />

          <TextField
            fullWidth
            type="tel"
            name="phone number"
            label="Phone number"
            autoComplete="tel"
            size="small"
            value={phoneNumber}
            onChange={(event) => setPhoneNumber(event.target.value)}
            onBlur={handleUpdatePhoneNumber}
            margin="dense"
            helperText=" "
            inputProps={{ maxLength: 15 }}
          />

          <GoogleAddressSearch
            id="address"
            size="small"
            handleCreateAddress={handleUpdateAddress}
            address={organisation?.address}
          />
        </Paper>
      </Grid>
    </Grid>
  );
}
